import { render, staticRenderFns } from "./field-display.vue?vue&type=template&id=2557931a&scoped=true"
import script from "./field-display.vue?vue&type=script&lang=js"
export * from "./field-display.vue?vue&type=script&lang=js"
import style0 from "./field-display.vue?vue&type=style&index=0&id=2557931a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2557931a",
  null
  
)

export default component.exports